import { FunctionComponent } from "react";

import {
  DefaultButton,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { dangerButtonStyles } from "@components/buttons/DangerButton";
import { ServerMigrationResponse } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { ServerMigrationFooter } from "./ServerMigrationFooter";
import { ServerMigrationOverview } from "./ServerMigrationOverview";
import { ServerMigrationSteps } from "./ServerMigrationSteps";

interface ServerMigrationReviewStageProps {
  validation: ServerMigrationResponse;
  isLoading: boolean;
  onContinue: () => void;
  onBack: () => void;
  onCancel: () => void;
}

export const ServerMigrationReviewStage: FunctionComponent<ServerMigrationReviewStageProps> = ({
  validation,
  isLoading,
  onContinue,
  onBack,
  onCancel
}) => {
  const theme = useTheme();

  return (
    <>
      <Stack tokens={{ childrenGap: theme.spacing.m }}>
        {validation.success ? (
          <MessageBar messageBarType={MessageBarType.warning}>
            Validation passed. Continuing will move this tenant to the new
            server, deactivate the current server and deactivate the new
            server&apos;s existing tenant. This cannot be undone from the Ops
            Console.
          </MessageBar>
        ) : (
          <MessageBar messageBarType={MessageBarType.error}>
            Validation failed. Review the steps below before trying again.
          </MessageBar>
        )}
        <ServerMigrationOverview response={validation} />
        <ServerMigrationSteps title="Validation" steps={validation.steps} />
      </Stack>
      <ServerMigrationFooter
        loadingText={isLoading ? "Migrating server..." : undefined}
      >
        {validation.success && (
          <PrimaryButton
            text="Continue"
            onClick={onContinue}
            disabled={isLoading}
            styles={dangerButtonStyles(theme)}
          />
        )}
        <DefaultButton text="Back" onClick={onBack} disabled={isLoading} />
        <DefaultButton text="Cancel" onClick={onCancel} disabled={isLoading} />
      </ServerMigrationFooter>
    </>
  );
};
